// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout-desktop-container{height:100%;width:100%}@media print{.layout-desktop-container{justify-content:center}}.layout-mobile-container{display:flex;flex-grow:1;flex-direction:column;height:100%;justify-content:space-between;width:100%}\n", ""]);
// Exports
module.exports = exports;
